import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export interface SickEntry {
  id: number;
  employeeId: string;
  employeeName: string;
  designation: string;
  fromDate: string;
  toDate: string;
  numOfDays: number;
  reason: string;
  status: 'pending' | 'approved' | 'rejected';
  userId: number;
  createdDate: number;
}

export interface CreateSickFormRequest {
  employeeId: string;
  employeeName: string;
  designation: string;
  fromDate: string;
  toDate: string;
  numOfDays?: number;
  reason: string;
}

export interface PaginatedSickFormResponse {
  data: SickEntry[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const sickFormApi = {
  getAll: (params: { page?: number; limit?: number }, token: string): Promise<PaginatedSickFormResponse> => {
    const q = new URLSearchParams();
    if (params.page) q.append('page', params.page.toString());
    if (params.limit) q.append('limit', params.limit.toString());
    return apiRequest<PaginatedSickFormResponse>(
      `${buildApiUrl(API_CONFIG.ENDPOINTS.SICK_FORM.BASE)}?${q}`,
      { method: 'GET', headers: getAuthHeaders(token) }
    );
  },

  create: (data: CreateSickFormRequest, token: string): Promise<SickEntry> =>
    apiRequest<SickEntry>(buildApiUrl(API_CONFIG.ENDPOINTS.SICK_FORM.BASE), {
      method: 'POST',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  update: (id: number, data: Partial<CreateSickFormRequest>, token: string): Promise<SickEntry> =>
    apiRequest<SickEntry>(buildApiUrl(API_CONFIG.ENDPOINTS.SICK_FORM.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  updateStatus: (id: number, status: 'pending' | 'approved' | 'rejected', token: string): Promise<SickEntry> =>
    apiRequest<SickEntry>(buildApiUrl(API_CONFIG.ENDPOINTS.SICK_FORM.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify({ status }),
    }),

  remove: (id: number, token: string): Promise<void> =>
    apiRequest<void>(buildApiUrl(API_CONFIG.ENDPOINTS.SICK_FORM.BY_ID(id)), {
      method: 'DELETE',
      headers: getAuthHeaders(token),
    }),
};
